module.exports = __webpack_public_path__ + "img/e2.04348e78.jpg";